<template>
  <v-card class="text-center pa-4" outlined elevation="2">
    <div
      style="
        border-radius: 200px;
        height: 200px;
        width: 200px;
        background: #f8faf5;
        margin: 0 auto;
      "
    >
      <i class="checkmark">✓</i>
    </div>
    <h1>Success</h1>

    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Shop</v-list-item-title>
          <v-list-item-subtitle>
            {{ shop }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Installation state</v-list-item-title>
          <v-list-item-subtitle>
            Installation complite with no problem 👌
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="ma-3"></v-divider>
    </v-list>

    <p>thanks ! 😃</p>
  </v-card>
</template>

<script>
export default {
  name: "shopifySuceess",
  data: () => {
    return {};
  },
  props: {
    shop: null,
  },
};
</script>

<style scoped>
h1 {
  color: #88b04b;
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-weight: 900;
  font-size: 40px;
  margin-bottom: 10px;
}
p {
  color: #404f5e;
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-size: 20px;
  margin: 0;
}
i {
  color: #9abc66;
  font-size: 100px;
  line-height: 200px;
  margin-left: -15px;
}
.card {
  background: white;
  padding: 60px;
  border-radius: 4px;
  box-shadow: 0 2px 3px #c8d0d8;
  display: inline-block;
  margin: 0 auto;
}
</style>
